import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_LESSON_TIMES } from '@/api/endpoints';
import { LESSON_TIMES_QUERY_KEY } from '@/api/queryKeys';
import type { LessonTime } from '@/types/diary';
import { unwrapAxiosResponse } from '@/utils/axios';

interface LessonTimeResponse {
  name?: string | null;
  from?: string | null;
  to?: string | null;
}

const toLessonTime = ({ name, from, to }: LessonTimeResponse): LessonTime => ({
  name: name ?? '',
  from: from ?? '',
  to: to ?? '',
});

const hasContent = ({ name, from, to }: LessonTime) => !!(name || from || to);

export const useLessonTimes = (isOpen: boolean) =>
  useQuery({
    queryKey: LESSON_TIMES_QUERY_KEY,
    enabled: isOpen,
    staleTime: Infinity,
    queryFn: () =>
      apiClient
        .get<LessonTimeResponse[]>(API_LESSON_TIMES)
        .then(unwrapAxiosResponse)
        .then((times) => times.map(toLessonTime).filter(hasContent)),
  });
